:<template>
  <div class="timetable">
    <div class="timetable__preview">
      <div class="timetable__item">
        <div class="timetable__day">{{currentDay.day_letter}}</div>
        <div class="timetable__intervals">
            <div class="timetable__interval" v-if="specialist && specialist.timetable && specialist.timetable[currentDay.day_en].length == 0">
              Indisponibil
            </div>
            <div class="timetable__interval" v-for="(day, index) in specialist.timetable[currentDay.day_en]" :key="index" v-else>
                {{day.start_time}} - {{day.end_time}}
            </div>
        </div>

        <i
          class="timetable__expand fas"
          :class="[{'fa-chevron-down':!this.expanded}, {'fa-chevron-up':this.expanded}]"
          id="timetable-expand" @click="clickTimetableButton"
        ></i>
      </div>
    </div>
    <div class="timetable__drawer" :class="[{'timetable__drawer--expanded': this.expanded}]" id="timetable-drawer">
      <div class="timetable__item" v-for="index in 6" v-if="index >= currentDayIndex" :key="index">
        <div class="timetable__day">{{selectedDay(index+1).day_letter}}</div>
        <div class="timetable__intervals">
          <div class="timetable__interval" v-if="specialist.timetable && specialist.timetable[selectedDay(index+1).day_en].length == 0">Indisponibil</div>
          <div class="timetable__interval" v-else-if="specialist && index >= currentDayIndex" v-for="(day, index) in specialist.timetable[selectedDay(index+1).day_en]" :key="index"> {{day.start_time}} - {{day.end_time}} </div>
        </div>
      </div>
      <div class="timetable__item" v-for="index in currentDayIndex" v-if="index < currentDayIndex" :key="index">
        <div class="timetable__day">{{selectedDay(index).day_letter}}</div>
        <div class="timetable__intervals">
          <div class="timetable__interval" v-if="specialist && specialist.timetable && specialist.timetable[selectedDay(index).day_en].length == 0">Indisponibil</div>
          <div class="timetable__interval" v-else-if="specialist && index < currentDayIndex" v-for="(day, index) in specialist.timetable[selectedDay(index).day_en]" :key="index"> {{day.start_time}} - {{day.end_time}} </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      expanded: false,
      currentDayIndex: new Date().getDay() || 7, //* !!! "getDay() || 7" fixes the fact that the week starts from Sunday (0) !!! */
    };
  },
  computed: {
    ...mapGetters({
      specialist: "specialist/specialist",
    }),
    currentDay: function () {
      let todayDate = new Date();
      let todayDateNr = todayDate.getDay() || 7; //* !!! "getDay() || 7" fixes the fact that the week starts from Sunday (0) !!! */

      switch (todayDateNr) {
        case 1:
          return {
            day_number: 1,
            day_en: "monday",
            day_letter: "L", //RO LANG
          };
          break;
        case 2:
          return {
            day_number: 2,
            day_en: "tuesday",
            day_letter: "M", //RO LANG
          };
          break;
        case 3:
          return {
            day_number: 3,
            day_en: "wednesday",
            day_letter: "Mi", //RO LANG
          };
          break;
        case 4:
          return {
            day_number: 4,
            day_en: "thursday",
            day_letter: "J", //RO LANG
          };
          break;
        case 5:
          return {
            day_number: 5,
            day_en: "friday",
            day_letter: "V", //RO LANG
          };
          break;
        case 6:
          return {
            day_number: 6,
            day_en: "saturday",
            day_letter: "S", //RO LANG
          };
          break;
        case 7:
          return {
            day_number: 7,
            day_en: "sunday",
            day_letter: "D", //RO LANG
          };
          break;
      }
    },
  },
  methods: {
    clickTimetableButton() {
        this.expanded = ! this.expanded;
    },
    selectedDay: function (daynr) {
      let todayDateNr = daynr;
      
      switch (todayDateNr) {
        case 1:
          return {
            day_number: 1,
            day_en: "monday",
            day_letter: "L", //RO LANG
          };
          break;
        case 2:
          return {
            day_number: 2,
            day_en: "tuesday",
            day_letter: "M", //RO LANG
          };
          break;
        case 3:
          return {
            day_number: 3,
            day_en: "wednesday",
            day_letter: "Mi", //RO LANG
          };
          break;
        case 4:
          return {
            day_number: 4,
            day_en: "thursday",
            day_letter: "J", //RO LANG
          };
          break;
        case 5:
          return {
            day_number: 5,
            day_en: "friday",
            day_letter: "V", //RO LANG
          };
          break;
        case 6:
          return {
            day_number: 6,
            day_en: "saturday",
            day_letter: "S", //RO LANG
          };
          break;
        case 7:
          return {
            day_number: 7,
            day_en: "sunday",
            day_letter: "D", //RO LANG
          };
          break;
      }
    },
  },
}
</script>

<style lang="scss">
.timetable {
    &__mobile {
        display: inline-block;

        @include media-breakpoint-up(xl) {
            display: none;
        }
    }

    &__desktop {
        display: none;

        @include media-breakpoint-up(xl) {
            display: block;
        }
    }
}

.timetable {
    color: y;
    display: flex;
    flex-direction: column;
    margin-top: 10px;

    &__item {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        margin-top: 10px;
        position: relative;
    }

    &__expand {
        cursor: pointer;
        color: #C3C6D1;
        position: absolute;
        right: -5px;
        transform: translateY(-50%);
        top: 16px;
    }

    &__day {
        align-items: center;
        background-color: #E6E8EE;
        border-radius: 50%;
        display: flex;
        font-size: 13.33px;
        height: 34px;
        justify-content: center;
        min-width: 34px;
        width: 34px;
    }

    &__intervals {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 0 18px -5px 15px;
    }

    &__interval {
        align-items: center;
        border: 2px solid #C3C6D1;
        border-radius: 17px;
        display: flex;
        font-size: 13.33px;
        height: 30px;
        justify-content: center;
        padding: 0px 10px;
        margin-bottom: 5px;

        &:not(:last-child) {
          margin-right: 15px;
        }
    }

    &__drawer {
        max-height: 0px;
        overflow: hidden;
        transition: max-height 1s ease;

        &--expanded {
            max-height: 460px;
            transition: max-height 1s ease;
        }
    }
}
</style>